import AutoPayIcon from '@assets/icons/autopay.svg';
import React from 'react';
import { BadgeAbsolute } from '@/components/badge-absolute';
import { useTheme } from '@/contexts/theme-context';

/**
 * "New" AutoPayIcon variant, includes a badge to indicate to the user that this is a new feature
 */
export const NewAutoPayIcon = () => {
  const theme = useTheme();

  return (
    <>
      <AutoPayIcon stroke={theme.sk.color.icon.primary} />
      <BadgeAbsolute />
    </>
  );
};
